import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import WOStatusFilterComponent from '../WOcomponents/WOStatusFilterComponent';
import WOTagCard from '../WOcomponents/WOTagCard';

export const GridContainer = styled(Grid)(({ theme }) => ({
  maxHeight: '18em',
  overflow: 'auto',
  margin: '0 !important',
  width: '100% !important',
  padding: '10px 16px',
  background: '#DDDDDDCC',

  [theme.breakpoints.up('md')]: {
    padding: '26px 16px 26px 0px',
  },

  '&::-webkit-scrollbar': {
    width: '0.625em',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#B3B3B3',
    border: '4px solid #B3B3B3',
    borderRadius: '8px',
    backgroundClip: 'padding-box',
  },
}));

const GridItemStyled = styled(Grid)(({ theme }) => ({}));

export default function VehicleDetailCard({
  relatedOrders,
  history,
  handleStartDone,
  onAddTechnician,
  enableOrderTagActions,
  isVendor,
  enableStatusFilter = true,
}) {
  return enableStatusFilter ? (
    <WOStatusFilterComponent
      orders={relatedOrders}
      isVendor={isVendor}
      history={history}
      handleStartDone={handleStartDone}
      onAddTechnician={onAddTechnician}
      enableOrderTagActions={enableOrderTagActions}
    />
  ) : (
    <GridContainer
      data-testid="vehicledetail-card"
      container
      alignItems="stretch"
      justify="space-around"
      spacing={0}
      rowSpacing={{ xs: 2 }}
      columnSpacing={{ xs: 2 }}
      margin={0}
    >
      {relatedOrders.map(order => (
        <GridItemStyled item xs={12} sm={6} md={3} lg={2.4}>
          <WOTagCard
            width="100%"
            key={order.vendorOrderId}
            data={order}
            history={history}
            handleStartDone={handleStartDone}
            addTechnician={() => onAddTechnician(order)}
            hasActionsEnabled={enableOrderTagActions}
            isVendor={isVendor}
          />
        </GridItemStyled>
      ))}
    </GridContainer>
  );
}
